export const GIFT_CARD_TEST_ID = 'gift-card';

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const GIFT_CARD_IMG_URL = String(require('./clover-gift-card.svg'));
